export default __webpack_public_path__ + "static/media/Verdana-Bold.548dd7e2.ttf";